import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Dudas constantes en entrevistas', 'Miedo a equivocarse', 'Inseguridad al intervenir', 'No saber cómo organizar evaluaciones', 'Sentir que improvisás demasiado', 'Bloquearte en devoluciones o informes', 'Desbordarte con familias y mensajes', 'Sentir que "todavía no estás lista"'];
export function PainPointsSection() {
  return <section className="py-16 relative" data-id="element-130">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-132">
          <p className="text-slate-500 italic mb-4" data-id="element-133">
            Si estás empezando clínica, dejame hacerte una pregunta honesta:
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 mb-6 uppercase tracking-tight" data-id="element-134">
            ¿Sentís que la facultad no te preparó para la práctica clínica real?
          </h2>
          <p className="text-lg text-slate-600 mb-6" data-id="element-135">
            Porque una cosa es estudiar teoría.
            <br data-id="element-136" />Y otra muy distinta es{' '}
            <span className="font-semibold text-pink-600" data-id="element-137">
              vivir la clínica real:
            </span>
          </p>
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3 max-w-2xl mx-auto mb-6 text-left" data-id="element-138">
            {['recibir una consulta real', 'hacer entrevistas', 'pensar evaluaciones', 'escribir informes', 'sostener familias', 'sentir que esperan respuestas de vos'].map((t, i) => <div key={i} className="flex items-start gap-2" data-id="element-139">
                <span className="text-pink-500 mt-1" data-id="element-140">·</span>
                <span className="text-slate-700" data-id="element-141">{t}</span>
              </div>)}
          </div>
          <p className="font-serif italic text-xl text-rose-500" data-id="element-142">
            Y ahí aparece la inseguridad. No porque no seas capaz. Sino porque
            nadie te enseñó realmente cómo empezar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-10 shadow-md border border-slate-100" data-id="element-143">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-6 text-center" data-id="element-144">
            Lo que muchas psicopedagogas sienten cuando empiezan clínica
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-145">
            {pains.map((p, i) => <div key={i} className="flex items-start gap-3" data-id="element-146">
                <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-147" />
                <span className="text-slate-700 font-medium" data-id="element-148">{p}</span>
              </div>)}
          </div>
          <p className="mt-8 text-center font-serif italic text-lg md:text-xl text-pink-600" data-id="element-149">
            Podrías trabajar con mucha más claridad… si tuvieras una guía más
            concreta.
          </p>
        </motion.div>
      </div>
    </section>;
}